<template>
  <navbar :branding="branding" :is-main-domain="isMainDomain" />

  <div style="margin-top: 54px">
    <router-view :class="{ 'has-bulma': $route.meta.bulma }"/>
  </div>
</template>

<script>
import Navbar from '../components/navbar.vue';

export default {
  name: 'app',
  components: {
    Navbar,
  },
  data() {
    const baseDomain = window.location.hostname.replace(/^docs\./, '');
    return {
      baseDomain,
      // This must start out as `null`, so we can check if it's been loaded.
      branding: null,
      isMainDomain: baseDomain === 'accept.blue',
      faviconEl: null,
    };
  },
  methods: {
    async fetchBranding() {
      try {
        const res = await fetch(`/branding/${this.baseDomain}/branding.json`);
        const branding = await res.json();
        this.branding = {
          baseDomain: this.baseDomain,
          gatewayName: branding.gatewayName,
          siteUrl: branding.siteUrl || `https://${this.baseDomain}`,
          prodBaseUrl: `https://api.${this.baseDomain}`,
          sandboxBaseUrl: `https://api.sandbox.${this.baseDomain}`,
        };
      } catch (err) {
        console.error(err);
        this.branding = {};
      }
    },
    setupDropdownListeners() {
      // https://github.com/jgthms/bulma/issues/2514#issuecomment-721454902
      // Add a listener to all dropdown menus to hide them after clicking an item - otherwise the menu stays open
      document.querySelectorAll('.has-dropdown')
          .forEach(el => {
            el.addEventListener('click', () => {
              let menu = el.querySelector('.navbar-dropdown');
              menu.style.display = 'none';
              setTimeout(() => {
                el.blur();
                // Reset the display property to its original state, so the menu can appear again next time
                menu.style.display = '';
              }, 200);
            });
          });
    },
  },
  async created() {
    this.faviconEl = document.querySelector('#favicon');

    await this.fetchBranding();

    this.faviconEl.href = `/branding/${this.baseDomain}/icon.png`;
  },
  mounted() {
    this.setupDropdownListeners();
  },
};
</script>

<style lang="scss">
// Only load Bulma for specific sections, but not Redoc, since it interferes with Redoc styles.
#navbar-wrapper, .has-bulma {
  @import '../styles/bulma-wrapper.scss';
}
</style>
